//function isMobile() {
//    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
//}
var mobile;
var desktop;

/**
 * Function qui dit si on est sur mobile
 */
export default function () {
    if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i) ||
        window.innerWidth <= 767 ) {
        mobile = true;
        desktop = false;
        document.documentElement.classList.remove('desktop');
        document.documentElement.classList.add('mobile');

    } else {
        desktop = true;
        mobile = false;
        document.documentElement.classList.remove('mobile');
        document.documentElement.classList.add('desktop');
        
    }

}


